<template>
  <Loader v-if="loading"></Loader>
  <div>
    <!-- Upload Sections Container -->
    <div class="upload-sections-container">
      <!-- POD Section -->
      <div class="upload-section pod-section">
        <Card class="upload-card">
          <template v-slot:header>
            <div class="card-header">
              <i class="pi pi-bolt header-icon"></i>
              <h1 class="header-title">Switch In POD Caricati</h1>
            </div>
          </template>
          <template v-slot:content>
            <div class="upload-content">
              <div class="upload-zone">
                <div class="button-wrapper">
                  <span class="label">{{
                    podFilesToUpload.length == 0
                      ? "Seleziona File"
                      : podFilesToUpload.length + " files"
                  }}</span>
                  <input type="file" ref="podFileInputRef" @change="handlePodFileUpload"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" multiple
                    class="upload-input" />
                </div>
              </div>
              <!-- Anteprima file POD -->
              <div v-if="podFilesToUpload.length > 0" class="file-preview-container">
                <h3>Anteprima File</h3>
                <ul class="file-preview-list">
                  <li v-for="(file, index) in podFilesToUpload" :key="index" class="file-preview-item">
                    <i class="pi pi-file file-icon"></i>
                    <span class="file-name">{{ file.name }}</span>
                    <button @click.prevent="removeFile('POD', index)" class="remove-button">
                      <i class="pi pi-times"></i>
                    </button>
                  </li>
                </ul>
              </div>
              <div v-show="validationErrors.podFiles && submitted" class="p-error">
                Campo richiesto.
              </div>
              <div v-show="validationErrors.podType && submitted" class="p-error">
                Formato non consentito
              </div>
              <div class="action-buttons">
                <Button @click="uploadFileSwitchInOnFtp('POD')" class="p-button-primary upload-button">
                  <i class="pi pi-upload"></i>
                  <span>Carica File</span>
                </Button>
              </div>
            </div>
          </template>
        </Card>
      </div>

      <!-- PDR Section -->
      <div class="upload-section pdr-section">
        <Card class="upload-card">
          <template v-slot:header>
            <div class="card-header">
              <i class="pi pi-fire header-icon"></i>
              <h1 class="header-title">Switch In PDR Caricati</h1>
            </div>
          </template>
          <template v-slot:content>
            <div class="upload-content">
              <div class="upload-zone">
                <div class="button-wrapper">
                  <span class="label">{{
                    pdrFilesToUpload.length == 0
                      ? "Seleziona File"
                      : pdrFilesToUpload.length + " files"
                  }}</span>
                  <input type="file" ref="pdrFileInputRef" @change="handlePdrFileUpload"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" multiple
                    class="upload-input" />
                </div>
              </div>
              <!-- Anteprima file PDR -->
              <div v-if="pdrFilesToUpload.length > 0" class="file-preview-container">
                <h3>Anteprima File</h3>
                <ul class="file-preview-list">
                  <li v-for="(file, index) in pdrFilesToUpload" :key="index" class="file-preview-item">
                    <i class="pi pi-file file-icon"></i>
                    <span class="file-name">{{ file.name }}</span>
                    <button @click.prevent="removeFile('PDR', index)" class="remove-button">
                      <i class="pi pi-times"></i>
                    </button>
                  </li>
                </ul>
              </div>
              <div v-show="validationErrors.pdrFiles && submitted" class="p-error">
                Campo richiesto.
              </div>
              <div v-show="validationErrors.pdrType && submitted" class="p-error">
                Formato non consentito
              </div>
              <div class="action-buttons">
                <Button @click="uploadFileSwitchInOnFtp('PDR')" class="p-button-primary upload-button">
                  <i class="pi pi-upload"></i>
                  <span>Carica File</span>
                </Button>
              </div>
            </div>
          </template>
        </Card>
      </div>
    </div>

    <!-- Unified Sync Button -->
    <div class="sync-container">
      <Button @click="sincronizzaSwin" class="p-button-secondary sync-button">
        <i class="pi pi-sync"></i>
        <span class="sync-text">Sincronizza</span>
      </Button>
    </div>

    <!-- History Section -->
    <div class="center-content">
      <Card class="history-card">
        <template v-slot:header>
          <br />
          <h3 class="page-title">Storico File Caricati</h3>
          <div class="filter-buttons-SwitchIn">
            <SelectButton v-model="selectedFilter" :options="filterOptions" @change="handleFilterChange"
              aria-labelledby="filter-type" :allowEmpty="false" optionLabel="name" optionValue="code" />
          </div>
        </template>
        <template v-slot:content>
          <div>
            <input type="text" v-model="searchQuery" placeholder="Cerca file..." class="file-search-input" />
          </div>
          <DataTable :value="filteredFiles" :paginator="true" :rows="filesPerPage" v-model:first="first"
            :rowsPerPageOptions="[10, 20, 50, 100]" tableStyle="min-width: 50rem" class="file-table">
            <Column field="file_name" header="File"></Column>
            <Column field="created_at" header="Data di caricamento"></Column>
            <Column field="name_fornitore" header="Tipologia"></Column>
            <Column field="email" header="Utente"></Column>
          </DataTable>
        </template>
      </Card>
    </div>

    <!-- Log History Section -->
    <div class="center-content">
      <Card class="history-card">
        <template v-slot:header>
          <br>
          <h3 class="page-title">Storico Elaborazione File</h3>
        </template>
        <template v-slot:content>
          <DataTable :value="logMessages" tableStyle="min-width: 50rem" class="file-table">
            <Column field="id" header="Id"></Column>
            <Column field="operation" header="Operation"></Column>
            <Column field="created_at" header="Created At">
              <template #body="{ data }">
                {{ moment(data.created_at).format('DD-MM-YYYY') }}
              </template>
            </Column>
          </DataTable>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
import { ref, computed, getCurrentInstance, onMounted } from "vue";
import { useStore } from "vuex";
import Service from "@/services/ask-caricamento-file/caricamento-file";
import Loader from "@/components/Loader.vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";

export default {
  name: 'FileUploadComponent',

  components: {
    Loader,
  },

  setup() {
    const store = useStore();
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const service = new Service(self.$eventBus);
    const allowedType = ["csv", "xlsx"];
    // File upload states
    const podFilesToUpload = ref([]);
    const pdrFilesToUpload = ref([]);
    const currentUser = ref(store.state.auth.user);
    const validationErrors = ref({});
    const submitted = ref(false);
    const loading = ref(false);
    const uploadedFiles = ref([]);
    const originalUploadedFiles = ref([]);
    const logMessages = ref([]);
    const first = ref(0);

    // Pagination and filtering
    const filesPerPage = ref(10);
    const searchQuery = ref("");
    const selectedFilter = ref("ALL");
    const filterOptions = [
      { name: "Tutti", code: "ALL" },
      { name: "POD", code: "POD" },
      { name: "PDR", code: "PDR" }
    ];

    // File Upload Handlers
    const handlePodFileUpload = (evt) => {
      evt.preventDefault();
      submitted.value = false;
      const files = evt.target.files;
      const validFiles = [];
      const maxSize = 500000 * 1024;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const fileExtension = file.name.split('.').pop().toLowerCase();

        // Verifica solo il tipo di file e la dimensione
        if (!['csv', 'xlsx'].includes(fileExtension)) {
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: `Il file ${file.name} deve essere in formato CSV o XLSX`,
          });
          continue;
        }

        if (file.size <= maxSize) {
          validFiles.push(file);
        } else {
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: `Il file ${file.name} supera la dimensione massima consentita (500 MB)`,
          });
        }
      }
      podFilesToUpload.value = validFiles;
    };

    const handlePdrFileUpload = (evt) => {
      evt.preventDefault();
      submitted.value = false;
      const files = evt.target.files;
      const validFiles = [];
      const maxSize = 500000 * 1024;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const fileExtension = file.name.split('.').pop().toLowerCase();

        // Verifica solo il tipo di file e la dimensione
        if (!['csv', 'xlsx'].includes(fileExtension)) {
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: `Il file ${file.name} deve essere in formato CSV o XLSX`,
          });
          continue;
        }

        if (file.size <= maxSize) {
          validFiles.push(file);
        } else {
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: `Il file ${file.name} supera la dimensione massima consentita (500 MB)`,
          });
        }
      }
      pdrFilesToUpload.value = validFiles;
    };

    // Upload and Sync Functions
    const uploadFileSwitchInOnFtp = (type) => {
      submitted.value = true;
      const filesToUpload = type === 'POD' ? podFilesToUpload.value : pdrFilesToUpload.value;

      if (validateForm(type)) {
        loading.value = true;

        service
          .uploadFileSwitchInOnFtp(filesToUpload, type)
          .then((response) => {
            const uploaded = response.files;

            uploaded.forEach((file) => {
              file.uploader = currentUser.value;
            });

            uploadedFiles.value = [...uploadedFiles.value, ...uploaded];

            const message = response.message || "File Caricati con successo";
            toast.add({
              severity: "success",
              summary: "Successo",
              detail: message,
              life: 5000,
            });

            // Reset dello stato corretto
            if (type === 'POD') {
              podFilesToUpload.value = [];
            } else {
              pdrFilesToUpload.value = [];
            }

            fetchUploadedFiles();
            sincronizzaSwin();
          })
          .catch((error) => {
            toast.add({
              severity: "error",
              summary: "Errore",
              detail: "Errore durante il caricamento dei file",
            });
          })
          .finally(() => {
            loading.value = false;
          });
      }
    };

    const sincronizzaSwin = () => {
      loading.value = true;

      service.sincronizzaSwin()
        .then((res) => {
          toast.add({
            severity: "success",
            summary: "Successo",
            detail: "Sincronizzazione completata",
          });
        })
        .catch((error) => {
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: "Sincronizzazione fallita",
          });
        })
        .finally(() => {
          loading.value = false;
        });
    };

    // Validation
    const validateForm = (type) => {
      const files = type === 'POD' ? podFilesToUpload.value : pdrFilesToUpload.value;
      const errorKey = type.toLowerCase();

      if (files.length === 0) {
        validationErrors.value[`${errorKey}Files`] = true;
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Nessun file selezionato",
        });
        return false;
      }
      const hasInvalidExtensions = files.some(file => {
        const extension = file.name.split('.').pop().toLowerCase();
        return !['csv', 'xlsx'].includes(extension);
      });

      if (hasInvalidExtensions) {
        validationErrors.value[`${errorKey}Type`] = true;
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Sono ammessi solo file CSV o XLSX",
        });
        return false;
      }

      return true;
    };
    // Data Fetching
    const fetchUploadedFiles = async () => {
      try {
        const filesResponse = await service.getAllUploadedFilesSwitchIn();
        const formattedFiles = filesResponse.map((file) => ({
          ...file,
          created_at: moment(file.created_at).format("YYYY-MM-DD HH:mm:ss"),
        }));
        uploadedFiles.value = formattedFiles;
        originalUploadedFiles.value = formattedFiles;
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante il recupero dei file",
        });
      }
    };

    const getLogsFileElaborazioneAskFileSwitchIn = async () => {
      loading.value = true;
      try {
        const response = await service.getLogsFileElaborazioneAskFile('process-switch-in');
        logMessages.value = response.items;
      } catch (error) {
        console.error("Errore durante il recupero dei log:", error);
      } finally {
        loading.value = false;
      }
    };

    const filteredFiles = computed(() => {
      let files = [...originalUploadedFiles.value];

      if (selectedFilter.value && selectedFilter.value !== "ALL") {
        files = files.filter(file => file.name_fornitore === selectedFilter.value);
      }

      if (searchQuery.value) {
        const searchLower = searchQuery.value.toLowerCase();
        files = files.filter(file =>
          file.file_name.toLowerCase().includes(searchLower) ||
          (file.name_fornitore && file.name_fornitore.toLowerCase().includes(searchLower)) ||
          (file.email && file.email.toLowerCase().includes(searchLower))
        );
      }

      return files;
    });

    const handleFilterChange = (event) => {
      selectedFilter.value = event.value;
      first.value = 0; 
    };
    const removeFile = (type, index) => {
      if (type === 'POD') {
        const updatedFiles = [...podFilesToUpload.value];
        updatedFiles.splice(index, 1);
        podFilesToUpload.value = updatedFiles;

        if (updatedFiles.length === 0) {
          if (self.$refs.podFileInputRef) {
            self.$refs.podFileInputRef.value = '';
          }
        }
      } else if (type === 'PDR') {
        const updatedFiles = [...pdrFilesToUpload.value];
        updatedFiles.splice(index, 1);
        pdrFilesToUpload.value = updatedFiles;

        if (updatedFiles.length === 0) {
          if (self.$refs.pdrFileInputRef) {
            self.$refs.pdrFileInputRef.value = '';
          }
        }
      }
    };

    onMounted(async () => {
      try {
        await fetchUploadedFiles();
        await getLogsFileElaborazioneAskFileSwitchIn();
      } catch (error) {
        console.error("Errore durante l'inizializzazione:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante il caricamento dei dati iniziali",
        });
      }
    });

    return {
      podFilesToUpload,
      pdrFilesToUpload,
      validationErrors,
      submitted,
      loading,
      uploadedFiles,
      logMessages,
      currentUser,
      first,
      allowedType,
      removeFile,
      filesPerPage,
      searchQuery,
      selectedFilter,
      filterOptions,
      filteredFiles,

      handlePodFileUpload,
      handlePdrFileUpload,
      uploadFileSwitchInOnFtp,
      sincronizzaSwin,
      handleFilterChange,

      moment
    };
  },
};
</script>

<style>
:root {
  --primary-color: #3B82F6;
  --success-color: #4CAF50;
  --border-color: #e2e8f0;
  --text-primary: #0f172a;
  --text-secondary: #475569;
  --bg-gradient: linear-gradient(0deg, #04ba2e 70%, #cad806 100%);
  --card-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
}

/* Layout and Container styles */
.center-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  padding: 1rem;
}

.upload-sections-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* Due colonne di uguale larghezza */
  gap: 2rem;
  padding: 2rem;
  max-width: 2000px;
  margin: 0 auto;
}

.upload-section {
  width: 100%;
}

/* Card and Header styles */
.upload-card {
  background: white;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  transition: transform 0.2s, box-shadow 0.2s;
}

.upload-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 12px 12px 0 0;
}

.header-icon {
  font-size: 2rem;
  color: #0ea5e9;
}

.header-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

/* Upload zone and button styles */
.upload-content {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.upload-zone {
  border: 2px dashed var(--border-color);
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  transition: all 0.2s;
}

.upload-zone:hover {
  border-color: var(--primary-color);
  background-color: #f8fafc;
}

.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin: 0 auto;
}

.button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #e5e5e5 !important;
  color: #544848;
  cursor: pointer;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  border-radius: 3px;
  box-shadow: 0 10px 13px -7px #00000050;
}

.upload-input {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

/* Action buttons */
.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.upload-button {
  padding: 0.75rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: #1f5d38;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* Sync button */
.sync-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 2rem 0;
}

.sync-button {
  width: 200px;
  padding: 0.75rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.sync-button i {
  transition: transform 0.5s ease-in-out;
}

.sync-button:active i {
  transform: rotate(360deg);
}

.file-table {
  width: 100%;
  border-collapse: collapse;
}

.file-table th,
.file-table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.file-table th {
  background: linear-gradient(0deg, #04ba2e 70%, #cad806 100%);
  font-weight: bold;
  color: white !important;
}


/* History card */
.history-card {
  width: 100%;
  margin-top: 2rem;
}

.page-title {
  font-size: 20px;
  text-align: center;
}

/* Filter styles */
.filter-buttons-SwitchIn {
  display: flex;
  justify-content: center;
  margin: 1rem 0;
}

.p-selectbutton {
  display: flex;
  justify-content: center;
  border-radius: 8px;
}

.p-selectbutton .p-button {
  background-color: white;
  font-weight: bold;
  transition: all 0.2s;
  padding: 10px 20px;
  border-radius: 8px;
  color: #414141;
}

.p-selectbutton .p-button:not(.p-disabled):not(.p-highlight):hover {
  background-color: #aaaaaa;
  color: white;
  box-shadow: 0 2px 10px rgba(39, 42, 46, 0.2);
}

.p-selectbutton .p-button.p-highlight {
  background: var(--success-color);
  border-color: var(--success-color);
  color: white;
}

/* Utility classes */
.file-search-input {
  margin-bottom: 10px;
  width: 10%;
  padding: 8px;
  border: 1px solid black;
  border-radius: 5px;
}

.file-count-select-wrapper {
  margin: 20px auto 0;
  width: fit-content;
}

.file-count-select {
  padding: 0.5rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
}
</style>
